import { h } from 'preact'
import ContentCurationList from './ContentCurationList'
import ContentCurationItem from './ContentCurationItem'
import ArticleIcon from '../assets/icon-content-type-article'
import QuestionIcon from '../assets/icon-content-type-question'
import AnswerIcon from '../assets/icon-content-type-answer'
import DiscussionIcon from '../assets/icon-content-type-discussion'
import IdeaIcon from '../assets/icon-content-type-idea'
import { CuratedTopic } from './HomepageContentCurationManager'

interface CuratedTopicWithIconAndIdx extends CuratedTopic {
  icon?: JSX.Element,
  idx?: number
}

interface Props {
  curatedTopics: Array<CuratedTopicWithIconAndIdx>,
  title: string
}

const HomepageContentCurationContainer = ({ title, curatedTopics = [] }: Props) => {
  const topicType = {
    'question': <QuestionIcon />,
    'article': <ArticleIcon />,
    'answer': <AnswerIcon />,
    'discussion': <DiscussionIcon />,
    'idea': <IdeaIcon />
  }

  if (!curatedTopics.length) {
    return null
  }

  return <section className='topic-curation__container homepage-widget-wrapper full-width custom-featured-topic-list'>
    <div className='sitewidth'>
      <div className='col'>
        <div className='box__pad'>
          <h3 className='widget__heading m-b'>{title}</h3>
          {
            curatedTopics.length ? (
              <ContentCurationList>
                { curatedTopics.map((item, idx) => {
                  item.icon = topicType[item.type]
                  item.idx = idx
                  return <ContentCurationItem {...item} />
                })}
              </ContentCurationList>
            ) : null
          }
        </div>
      </div>
    </div>
  </section>
}

export default HomepageContentCurationContainer
